import React from 'react';
const SvgChevronRight = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 32 32", focusable: false }, props),
    React.createElement("path", { d: "M9.757 32l-2.9-2.91L19.937 16 6.857 2.91 9.757 0l16 16z", fillRule: "evenodd" })));
export default SvgChevronRight;
//# sourceMappingURL=ChevronRight.js.map